import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const Dialog = () => {
    return (
        <div className="dialog animated fadeIn" style={{animationDuration: 0.5 + 's'}}>
          <div className="dialog-container">
            <div className="text">Generating pdf<div className="loading-animation"></div></div>
          </div>
        </div>
    );
};

Dialog.propTypes = {
    app: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        app: state.app
    };
};

export default connect(
    mapStateToProps
)(Dialog);
